import { FieldFillingFunctionType } from '../types/interfaces';

export const FieldFillingFunctionOptions: FieldFillingFunctionType[] = [
  {
    label: 'Установить текущее значениe',
    action: '', // Значение функции
    id: '5d3a56a2-4db3-4355-af6c-6644558cca61'
  },
  {
    label: 'Запретить изменения после перехода',
    action: '',
    id: '3b47c258-9615-4407-bfc7-10f606679b5f'
  }
];
